'use client';

import { useQuery } from '@tanstack/react-query';
import type { FC } from 'react';
import { TrackingDataProvider } from '../../common/components/TrackingDataProvider';
import { PopularProducts } from '../../product/components/PopularProducts';
import { profileFactory } from '../../query-factory/profile.factory';

export const MyShopPopularProducts: FC = () => {
  const { data: userInfo } = useQuery({
    ...profileFactory.userInfo,
  });

  if (!userInfo?.snsTitle) return null;

  return (
    <TrackingDataProvider
      data={{
        page_name: 'curator_shop_manage',
        section_name: 'CurationPopularProductSection',
        section_title: '인기 상품',
        selection_id: `curator_${userInfo?.snsTitle}`,
      }}
    >
      <PopularProducts snsTitle={userInfo?.snsTitle} />
    </TrackingDataProvider>
  );
};
